import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
let BehaviorApi = class BehaviorApi {
    constructor(http, urls) {
        this.http = http;
        this.urls = urls;
    }
    postDepartmentTreeByIds(params) {
        return this.http.post({
            url: this.urls.getEmailsTree,
            params,
            cache: true,
        });
    }
    /** 获取 企业 用户登录情况 */
    postCustomerLoginList(data) {
        const url = this.urls.postCustomerLoginList;
        return this.http.post({
            url,
            data,
        });
    }
    /** 获取看板踢人列表 */
    postPrivilegeConcurrencyList(params, data) {
        const url = this.urls.postPrivilegeConcurrencyList;
        return this.http.post({
            url,
            params,
            data,
        });
    }
};
BehaviorApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.BehaviorUrls)),
    __metadata("design:paramtypes", [Object, Object])
], BehaviorApi);
export { BehaviorApi };
